import React, { useReducer } from 'react'
import { UserVerificationFormDataReducer, userVerificationFormDataInitialState } from './UserVerificationFormDataReducer';
import { UserVerificationFormValidationReducer, userVerificationFormValidationInitialState } from './UserVerificationFormValidationReducer';
import { FormField } from '../../uiwidgets/FormField';
import { FormContainer } from '../../uiwidgets/FormContainer';
import { SubmitButton } from '../../uiwidgets/SubmitButton';
import { Row, Col, Alert,Spinner } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { validateInput } from "./UserVerificationValidationService";
import { kickOffFullFormValidation } from 'util/Validators';
import PageContentContainer from 'uiwidgets/PageContentContainer';

function UserVerificationPage(props) {

  const [formData, formDispatch] = useReducer(UserVerificationFormDataReducer, userVerificationFormDataInitialState);
  const [formValidityData, formValidityDispatch] = useReducer(UserVerificationFormValidationReducer, userVerificationFormValidationInitialState);
  const { userId } = useParams();

  const handleChange = (event) => {
    if (false) {
      return;
    }
    const name = event.target.name;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    formDispatch({ type: 'FIELD_EDIT', payload: { name: name, value: value } })
  }

  const handleValidation = (event) => {
    if (false) {
      return;
    }
    let dispatchType = 'VALIDATE_' + event.target.name.toUpperCase();
    const name = event.target.name;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    formValidityDispatch({ type: dispatchType, payload: { [name]: value } })
  }


  const userVerificationSuccessHandler = (data) => {
    formDispatch({ type: 'FORM_SUBMIT_SUCCESS', payload: data });
  };

  const userVerificationFailureHandler = (data) => {
    formDispatch({ type: 'FORM_SUBMIT_FAIL', payload: data });
  };


  const handleSubmit = (event) => {
    event.preventDefault();
    let formDataEvent = {
      ...event,
      formData: formData,
      formDataIsIsolated: false
    }
    let isFormValid = kickOffFullFormValidation(formDataEvent, formValidityDispatch, validateInput);

    if (!isFormValid) {
      alert("The form still has validation errors!");
      return false;
    }

    formDispatch({
      type: 'FORM_SUBMIT', payload: {
        formData: { ...formData, userId: userId },
        successFunction: userVerificationSuccessHandler,
        failureFunction: userVerificationFailureHandler
      }
    });
  }

  return (
    <>
      {formData.status && <PageContentContainer><Alert key="info" variant='info'>
        <Spinner animation="border" role="status" variant='dark' className="me-4" />
        {formData.status}
      </Alert></PageContentContainer>}
      <FormContainer title="User Verification" submitButtonFunction={handleSubmit}
        errors={formData.errors} infoMessage={formData.infoMessage} className="profile-form">
        {formData.verificationSuccessful && <Link to="/Login" className="link-danger">Login</Link>}
        <Row className="userVerification">
          <Col>
            <FormField name="verificationCode" label="Verification Code" type="text" value={formData.verificationCode}
              placeholder="Verification Code" onChange={handleChange} onBlur={handleValidation}
              valstate={!formValidityData.verificationCodeError} valMsg={formValidityData.verificationCodeErrMsg}
              readOnly={formData.readOnly} />
          </Col>
        </Row>
        <Row>
          <Col>
            <FormField name="email" label="Email" type="text" value={formData.email}
              placeholder="Email" onChange={handleChange} onBlur={handleValidation}
              valstate={!formValidityData.emailError} valMsg={formValidityData.emailErrMsg}
              readOnly={formData.readOnly} />
          </Col>
        </Row>
        <Row><Col>&nbsp;</Col></Row>
        <Row><Col>
          {!formData.verificationSuccessful && <SubmitButton label='Verify User' />}
        </Col></Row>
      </FormContainer>
    </>
  )
}

export default UserVerificationPage;
